var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGnaiChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0987 6.07735L20.625 1.1547L29.1513 6.07735V15.9227L20.625 20.8453L12.0987 15.9227V6.07735Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5987 11.5774L30.125 6.6547L38.6513 11.5774V21.4227L30.125 26.3453L21.5987 21.4227V11.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5987 22.0774L30.125 17.1547L38.6513 22.0774V31.9227L30.125 36.8453L21.5987 31.9227V22.0774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0987 27.5774L20.625 22.6547L29.1513 27.5774V37.4227L20.625 42.3453L12.0987 37.4227V27.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47372 22.0774L11 17.1547L19.5263 22.0774V31.9227L11 36.8453L2.47372 31.9227V22.0774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47372 11.5774L11 6.6547L19.5263 11.5774V21.4227L11 26.3453L2.47372 21.4227V11.5774Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 21.6822H19.0692V22.4656H18.8759L18.7895 22.3158C18.6634 22.4386 18.4968 22.5 18.2898 22.5C18.069 22.5 17.8819 22.4379 17.7283 22.3138C17.5761 22.1896 17.5 22.0216 17.5 21.8097V21.7045C17.5 21.4912 17.5768 21.3232 17.7303 21.2004C17.8853 21.0762 18.0759 21.0142 18.3021 21.0142C18.4707 21.0142 18.6175 21.0493 18.7422 21.1194C18.8684 21.1896 18.9561 21.2841 19.0055 21.4028L18.7011 21.5162C18.6216 21.361 18.4879 21.2834 18.3 21.2834C18.167 21.2834 18.058 21.3219 17.973 21.3988C17.8894 21.4757 17.8476 21.581 17.8476 21.7146V21.8016C17.8476 21.9325 17.8901 22.0371 17.9751 22.1154C18.0601 22.1923 18.1684 22.2308 18.3 22.2308C18.5098 22.2308 18.6593 22.1316 18.7484 21.9332H18.335V21.6822Z",
    fill: "#F1935C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3958 22.4656V21.0486H19.7187L20.5742 21.9737H20.5784V21.0486H20.9074V22.4656H20.5928L19.7289 21.5243H19.7228V22.4656H19.3958Z",
    fill: "#F1935C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5684 22.4656L22.4635 22.2308H21.6141L21.5092 22.4656H21.1431L21.8239 21.0364H22.2661L22.9448 22.4656H22.5684ZM21.7334 21.9636H22.3442L22.0419 21.2814H22.0378L21.7334 21.9636Z",
    fill: "#F1935C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1771 21.2409V21H23.5V21.2409H23.1771ZM23.1771 22.4656V21.3988H23.5V22.4656H23.1771Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnaiChat);
export default __webpack_public_path__ + "static/media/gnai-chat.f7c18e9c6f43da681c38021ffb0ab130.svg";
export { ForwardRef as ReactComponent };